import thunk from 'redux-thunk';
import serverVars from 'server-vars';
import { initializePrerenderedCheckout } from 'dibs-checkout/exports/prerender/initializePrerenderedCheckout';
import { getItemIdFromUri } from '../../utils/getItemIdFormUri';

/* Queries */
import { pdpRespCondensedRootQuery } from '../../queries/pdpRespCondensedRoot';

/* Reducers */
import { defaultReducers } from '../../reducers/reducerUtils';
import { pdpRespSimilarItemsReducer as similarItems } from '../../reducers/pdpRespSimilarItemsReducer';

/* Components */
import { PdpRespCondensedLayout } from '../../pdp/PdpRespCondensedLayout';

/* Helpers */
import { createEntry } from '../createEntry';
import { initializeDBL } from 'dibs-buyer-layout/src/entries';
import { initPdpDatadogRum } from '../../shared/helpers/initPdpDatadogRum';
import { pdpTypes } from '../../shared/helpers/pdpTypes';

/**
 * DBL has a different environment that's created in initializeDBL.
 */
const options = {
    middleware: [thunk],
    reducers: {
        similarItems,
        ...defaultReducers,
    },
};

const itemId = getItemIdFromUri(window.location.pathname);

initPdpDatadogRum({ pdpType: pdpTypes.condensed, device: 'resp' });

initializeDBL(options).then(async ({ store }) => {
    createEntry({
        Container: PdpRespCondensedLayout,
        store,
        query: pdpRespCondensedRootQuery,
    });

    const locale = serverVars.get('locale');
    const messages = serverVars.get('messages');

    if (itemId) {
        await initializePrerenderedCheckout({
            isMobile: false,
            itemId,
            locale,
            messages,
        });
    }
});
